/* eslint-disable max-len */
import React from "react";
import MuiButton from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

import InfoIcon from "@mui/icons-material/Info";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import RefreshIcon from "@mui/icons-material/Refresh";

const getIcon = (type: IconType, size: IconButtonSize) => {
  switch (type) {
    case "info":
      return <InfoIcon fontSize={size} />;
    case "copy":
      return <FileCopyIcon fontSize={size} />;
    case "refresh":
      return <RefreshIcon fontSize={size} />;

    default:
      return <InfoIcon fontSize={size} />;
  }
};

type IconType = "info" | "copy" | "refresh";
type IconButtonSize = "small" | "medium";

export type IconButtonProps = {

  /**
   * Button size (small by default)
   */
  size?: IconButtonSize;

  /**
   * Icon type (info by default)
   */
  type?: IconType

  /**
   * Whether the button should show a loading indicator
   */
  loading?: boolean

  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
}

export const IconButton: React.FC<IconButtonProps> = ({
  size = "small",
  type = "info",
  loading = false,
  onClick = () => null,
}: IconButtonProps) => (
  <MuiButton
    sx={{ padding: 1, minWidth: 32 }}
    variant="contained"
    color="primary"
    size={size}
    onClick={onClick}
  >
    {loading ? <CircularProgress color="inherit" size={24} /> : getIcon(type, size)}
  </MuiButton>
);
